import { combineReducers } from 'redux';
import eventsReducer from "./eventsReducer"; 
import betsReducer from "./betsReducer";
import messageReducer from "./messageReducer"; 
import balanceReducer from "./balanceReducer"; 

const rootReducer = combineReducers({
    eventsReducer,
    betsReducer,
    messageReducer,
    balanceReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.js